import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { IUserDefinedInformationKey } from "../../../../documaker/domain/format/objects";
import { IUserDefinitionSpecification } from "..";

export interface IUserDefinedInformationKeyPropertyEditable {
  userDefinedInformationKey(): IPropertyEditable<IUserDefinedInformationKey>;
  getSelectableUserDefinedInformations(): IUserDefinitionSpecification[];
}

export function instanceOfIUserDefinedInformationKeyPropertyEditable(instance: any): instance is IUserDefinedInformationKeyPropertyEditable {
  return instance
      && instance.userDefinedInformationKey
      && instance.getSelectableUserDefinedInformations
      && instanceOfIPropertyEditable<string>(instance.userDefinedInformationKey());
}
